import React, {
  memo,
  useState,
  useEffect,
  useRef,
  lazy,
  Suspense,
} from "react";
import { useSelector } from "react-redux";

import Icon from "../../assets/icons/Icon";
import { Input, Label } from "../";
import { uiActions } from "../../store/ui/ui-slice";
import { Link } from "react-router-dom";
import { logoutUser } from "../../store/user/user-action";
import { dispatch } from "../../store";

const Image = lazy(() => import("../UI/Image"));

const TopBarOptions = ({ user }) => {
  const root = document.documentElement;
  const dropdownRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const { theme } = useSelector((state) => state.ui);

  // using for dark theme only development mode
  // useEffect(() => {
  //   if (process.env.NODE_ENV === "development") {
  //     root.setAttribute("data-theme", "dark");
  //     dispatch(uiActions.setTheme("dark"));
  //   }
  // }, []);

  // Handle outside click to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!dropdownRef.current?.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  // handle theme on refresh
  useEffect(() => {
    if (theme) {
      root.setAttribute("data-theme", theme);
    }
  }, [theme]);

  const handleTheme = () => {
    const currentTheme = root.getAttribute("data-theme");

    if (currentTheme === "dark") {
      root.setAttribute("data-theme", "light");
      dispatch(uiActions.setTheme("light"));
    } else {
      root.setAttribute("data-theme", "dark");
      dispatch(uiActions.setTheme("dark"));
    }
  };

  const handleLogout = async () => {
    await logoutUser(dispatch);
  };

  return (
    <div className="user_name_box user-id" ref={dropdownRef}>
      <button
        type="button"
        className="profile-inner-circle"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-expanded={isOpen}
      >
        <div className="img_box">
          <Suspense fallback={null}>
            <Image src="/assets/images/user.png" alt="User Profile" />
          </Suspense>
        </div>
        <p className="m-0">
          {user?.unique_name || `User`} <Icon name="FaCaretDown" />
        </p>
      </button>

      <div className={`profile-hover-main ${isOpen ? "profile-open" : ""}`}>
        <div className="drp-setting-cover">
          <div className="theme-cover_box">
            <p className="dropdown-search">Theme</p>
            <div className="theme-switcher">
              <Input
                id="checkbox"
                type="checkbox"
                className="checkbox form-check-input"
                checked={theme === "light"}
                onChange={handleTheme}
              />
              <Label htmlFor="checkbox" className="checkbox-label">
                <Image src="/assets/images/sone.png" alt="Sun Icon" />

                <Image src="/assets/images/moon.png" alt="Moon Icon" />

                <span className="ball"></span>
              </Label>
            </div>
          </div>
        </div>

        <ul className="user-report">
          <li>
            <Link
              to="/twofactorauth"
              className="user_report-tex border_profile"
            >
              <Icon name="FaHandSparkles" />
              2FA Auth
            </Link>
          </li>
          <li>
            <Link
              to="/changepassword"
              className="user_report-tex border_profile"
            >
              <Icon name="FaUnlockAlt" />
              Change Password
            </Link>
          </li>
          <li>
            <p className="user_report-tex" onClick={handleLogout}>
              <Icon name="FaSignOutAlt" />
              Log Out
            </p>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default memo(TopBarOptions);
